import React, { useCallback } from 'react';

import { Tabs, Tab } from '../../shared/tabs.component';

import { TabTypes } from './constants';
import { useDefaultTab } from './useDefaultTab';

type ViewImportTabsProps = {
  activeTab: string,
  changeTab: (tab: TabTypes) => void,
  renderViewTab: () => React.ElementType | any,
  renderImportTab: () => React.ElementType | any,
  viewTabOnly: boolean,
  canModify?: boolean,
  additionalTabs?: React.ElementType[],
};

export const ViewImportTabs = ({
  activeTab,
  changeTab,
  renderViewTab,
  renderImportTab,
  additionalTabs = [],
  viewTabOnly = true,
  canModify = false,
}: ViewImportTabsProps) => {
  useDefaultTab({
    canModify,
    changeTab,
    activeTab,
  });

  const onTabChange = useCallback(
    (_, activeTab) => changeTab(activeTab),
    [changeTab]
  );

  const tabs = viewTabOnly
    ? (
      <Tab value={TabTypes.VIEW} label="View">
        {renderViewTab()}
      </Tab>
    )
    : [
      <Tab value={TabTypes.VIEW} key={TabTypes.VIEW} label="View">
        {renderViewTab()}
      </Tab>,
      <Tab value={TabTypes.IMPORT} key={TabTypes.IMPORT} label="Import">
        {renderImportTab()}
      </Tab>,
      ...additionalTabs,
    ];


  return (
    <Tabs
      defaultValue={TabTypes.VIEW}
      value={activeTab}
      onChange={onTabChange}
      className="a-tab-bar-margin-10"
      size="md"
    >
      {tabs}
    </Tabs>
  );
};
